import { createContext, useContext } from "react";
import type { DatePickerContext as DatePickerContextType } from "./types";

const DatePickerContext = createContext<DatePickerContextType | undefined>(
  undefined,
);

export const DatePickerProvider = DatePickerContext.Provider;

export const useDatePickerContext = () => {
  const context = useContext(DatePickerContext);
  if (!context) {
    throw new Error(
      "useDatePickerContext must be used within a DatePickerProvider",
    );
  }
  return context;
};
